import { Router } from '@angular/router';
import { UserService } from '../services';
import { UserRole } from '@ml/core/types/enums';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/user.service";
var AdminGuard = /** @class */ (function () {
    function AdminGuard(router, userService) {
        this.router = router;
        this.userService = userService;
    }
    AdminGuard.prototype.canActivate = function (next, state) {
        var user = this.userService.user;
        if (user.role === UserRole.ADMIN) {
            return true;
        }
        if (user.role === UserRole.CUSTOMER) {
            this.router.navigate(['customer-orders']);
        }
        else {
            this.router.navigate(['tasks']);
        }
        return false;
    };
    AdminGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdminGuard_Factory() { return new AdminGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.UserService)); }, token: AdminGuard, providedIn: "root" });
    return AdminGuard;
}());
export { AdminGuard };
